import { useLink } from 'react-router-stack';
import { isSmartPhone, random } from '../../utilities/helper';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MatchMakingMWeb from './index_mWeb';
import MatchMakingWeb from './index_web';
import avatarsList from '../../constants/avatars';
import { opponentNames } from '../../constants/match_making';
import { setOpponentUserDetail } from '../../actions/user-actions-types';
import useWindowOrientation from '../../utilities/hooks/useWindowOrientation';
const MatchMaking = () => {
  const link = useLink();
  const { gameDetails } = useSelector((state: any) => state.minigames);
  const {
    gameSlug,
    contest: { entryFee = 0 }
  } = gameDetails;
  const { username: myUserName = 0, avatarId: myAvatarId = 0 } = useSelector(
    (state: any) => state.user
  );
  const [opponentUser, setOpponentUser] = useState({});
  const [matchFound, setMatchFound] = useState(false);
  const avatars: any = { ...avatarsList };
  const { isLandscape } = useWindowOrientation();
  const dispatch = useDispatch();
  useEffect(() => {
    const matchFoundTime: any = Math.floor(Math.random() * 20 + 1) * 1000;
    const matchFoundController = setTimeout(() => {
      setMatchFound(true);
    }, matchFoundTime);
    const opponentUserProbability = random(1, 10);
    const opponentUserDetail: any = {
      username: opponentNames[opponentUserProbability].name,
      avatarId: opponentNames[opponentUserProbability].avatarId,
      avatar: opponentNames[opponentUserProbability].avatar
    };
    setOpponentUser(opponentUserDetail);
    dispatch(setOpponentUserDetail(opponentUserDetail));

    return () => {
      clearTimeout(matchFoundController);
    };
  }, []);

  useEffect(() => {
    let joinMatchEntryTime: any;
    if (matchFound) {
      joinMatchEntryTime = setTimeout(() => {
        link.push(`/games/${gameSlug}`);
      }, 2000);
    }
    return () => {
      clearTimeout(joinMatchEntryTime);
    };
  }, [matchFound]);

  const onCancelHandler = () => {
    link.replace('/');
  };

  return (
    <>
      {isSmartPhone && !isLandscape ? (
        <MatchMakingMWeb
          onCancelHandler={onCancelHandler}
          matchFound={matchFound}
          opponentUser={opponentUser}
          myUserName={myUserName}
          myAvatarId={myAvatarId}
          avatars={avatars}
          entryFee={entryFee}
        />
      ) : (
        <MatchMakingWeb
          onCancelHandler={onCancelHandler}
          matchFound={matchFound}
          opponentUser={opponentUser}
          myUserName={myUserName}
          myAvatarId={myAvatarId}
          avatars={avatars}
          isLandscape={isLandscape}
          entryFee={entryFee}
        />
      )}
    </>
  );
};
export default MatchMaking;
